import React from 'react'
import "./AboutUs1.css"

import aboutus_1         from "../../assets/aboutus/_aboutus_1.avif"
import aboutus_2         from "../../assets/aboutus/_aboutus_2.avif"
import aboutus_3         from "../../assets/aboutus/_aboutus_3.avif"
import aboutus_4         from "../../assets/aboutus/_aboutus_4.avif"
import _codingtraining_5         from "../../assets/codingtraining/_codingtraining_5.avif"
import _codingtraining_6         from "../../assets/codingtraining/_codingtraining_6.avif"
import _codingtraining_7         from "../../assets/codingtraining/_codingtraining_7.avif"
import _codingtraining_8         from "../../assets/codingtraining/_codingtraining_8.avif"

// src\assets\aboutus\_aboutus_1.avif



import Title from '../_title/Title'

export const appAndProjectDatabase1 = [
  {
      id: 1,
      position: "Co-founder, and Software Development",
      image: aboutus_1,
      title: "Peter Zorve, Ph.D.",
      abstract: "Peter is a Ghanaian academic and entrepreneur with a Ph.D. in Computational Chemistry from the University of Eastern Finland. Peter drives the development of our user-centric solutions through his deep technological expertise and an unwavering commitment to innovation.",
  },
  {
      id: 2,
      position: "Co-founder and Business Operations",
      image: aboutus_2,
      title: "Olusegun Akinyemi, Ph.D.",
      abstract: "Olusegun is a dynamic expert in academia and industry. He holds a Ph.D. in Science, Forestry, and Technology from the University of Eastern Finland. He drives our strategic operations, partnerships, and product development, facilitating EduZolve’s growth and success.",
  },
  {
      id: 3,
      position: "Communications and Marketing",
      image: aboutus_3,
      title: "Anastasia Doronina, B.Sc.",
      abstract: "Anastasia holds a degree in International Business from the University of Economics and Business in Prague. With global marketing experience, she brings creativity and strategic insight to the company’s branding and communications.",
  },
    {
      id: 4,
      position: "Sales and Marketing",
      image: aboutus_4,
      title: "Daniel Brobbey, M.Sc.",
      abstract: "Daniel is our Ghana-based team lead for Sales and Marketing. His vast experience in Ghana`s educational sector brings real-life perspectives into our sales and marketing processes.",
  },
];



const AboutUs1 = () => {
  return (
    <div className="aboutus-1-main-container-1">
      <div className="aboutus-1-sub-container-2">
        <Title title="OUR TEAM"/>
        {/* <Title title="Nationwide Coding, AI & Digital Skills Program (JHS & SHS Focus)"/> */}
        <div className='aboutus-1-sub-container-3'>
          <h2>
            The strength of EduZolve Oy lies in its team of dedicated professionals with diverse expertise. Our team members bring years of experience in software engineering, data science, machine learning, research, teaching, business, and start-up entrepreneurship. This collective knowledge allows us to develop cutting-edge solutions and provide students with the guidance they need to succeed in a competitive world.
          </h2>
        </div>

        <div className='aboutus-1-sub-container-4'>
            {appAndProjectDatabase1.map((program, index) => (
              <AboutUs1DisplayData key={program.id} program={program} index={index} />
            ))}
        </div>

    </div>
    </div>
  )
}


const AboutUs1DisplayData = ({ program, index }) => {
  const backgroundClass =
    index === 0 || index === 3 ? "bg-style-1"   
      : "bg-style-2"; 

  return (
    <div className={`aboutus-1-display-container-5 ${backgroundClass}`}>
      <img src={program.image} alt="" />
      <div className="aboutus-1-display-container-6">
        <h2>{program.position}</h2>
        <h4>{program.title}</h4>
        <h2>{program.abstract}</h2>
      </div>
    </div>
  );
};

export default AboutUs1